import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/http-client.service';
import { authenticatorApi } from '../../constants/authentecator-api';

@Injectable({
  providedIn: 'root'
})
export class F2aService {

  private readonly httpClientService = inject(HttpClientService);

  shouldReload = new BehaviorSubject<any>({ updated: false });
  shouldReload$ = this.shouldReload.asObservable();
  constructor() { }
  
  getUserWise2FA(userId: string): Observable<any> {
    return this.httpClientService.get(`${authenticatorApi.authenticator2FA}/${userId}`)
  }
  postUserWise2FA(data: any): Observable<any> {
    return this.httpClientService.post(`${authenticatorApi.authenticator2FA}`, data)
  }
  remove(id: any): Observable<any> {
    return this.httpClientService.delete(`${authenticatorApi.authenticator2FA}/${id}`)
  }
  updateUsers(id: any,payload:any): Observable<any> {
    return this.httpClientService.put(`${authenticatorApi.updatedUser}/${id}`,payload)
  }


}
